import styles from './Card.module.scss';

const Card = ({ title, timeFrames, period }) => {
  const cardColors = {
    work: 'hsl(15, 100%, 70%)',
    play: 'hsl(195, 74%, 62%)',
    study: 'hsl(348, 100%, 68%)',
    exercise: 'hsl(145, 58%, 55%)',
    social: 'hsl(264, 64%, 52%)',
    selfcare: 'hsl(43, 84%, 65%)',
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        background: `${cardColors[title.toLowerCase().split(' ').join('')]}`,
      }}
    >
      <img
        src={`./assets/images/icon-${title
          .toLowerCase()
          .split(' ')
          .join('-')}.svg`}
        alt="icon"
      />
      <div className={styles.title}>
        <div className={styles.titleRow}>
          <h1 className={styles.titleName}>{title}</h1>
          <div className={styles.dots}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
          </div>
        </div>
        <div className={styles.data}>
          <h2>{timeFrames[period].current}hrs</h2>
          <h3>Last Week - {timeFrames[period].previous}hrs</h3>
        </div>
      </div>
    </div>
  );
};

export default Card;
